import { AiOutlineArrowLeft } from "react-icons/ai";

const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-prev-arrow slick-arrow slick-2" onClick={onClick}>
            <AiOutlineArrowLeft />
        </div>
    );
};

export default CustomPrevArrow;